// extracted by mini-css-extract-plugin
export default {"card":"d_-z","carousel":"e_-z"};